import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export const menuItems = [
  {
    linkTo: '/',
    linkKey: 'menu_panel',
    icon: 'houseDoor',
  },
  {
    linkTo: '/calendar',
    linkKey: 'menu_calendar',
    icon: 'calendarDate2',
    permission: 207,
    requiredModule: MODULE_KEY_MAP.CALENDAR,
  },
  {
    linkTo: '/agenda',
    linkKey: 'menu_agenda',
    icon: 'list',
    permission: 230,
    requiredModule: MODULE_KEY_MAP.AGENDA,
  },
  {
    linkKey: 'menu_contracts-generator',
    icon: 'filePlus',
    children: [
      {
        linkTo: '/generador-contratos/generador',
        linkKey: 'menu_generator',
      },
      {
        linkTo: '/generador-contratos/contratos',
        linkKey: 'menu_contracts',
      },
    ],
  },
  {
    linkTo: '/estado-diario',
    linkKey: 'menu_dailyState',
    icon: 'calendar1',
    permission: 35,
    requiredModule: MODULE_KEY_MAP.DAILY_STATE,
  },
  {
    linkTo: '/tareas',
    linkKey: 'menu_tasks',
    icon: 'squareCheck',
    permission: 39,
    requiredModule: MODULE_KEY_MAP.TASKS,
  },
  {
    linkTo: '/causas',
    linkKey: 'menu_cases',
    icon: 'briefcase',
    permission: 40,
    requiredModule: MODULE_KEY_MAP.CASES,
  },
  {
    linkKey: 'menu_eepp',
    icon: 'fileText',
    permission: 40,
    requiredModule: MODULE_KEY_MAP.CASES,
    children: [
      {
        linkTo: '/escrituras/triage',
        linkKey: 'menu_eepp_triage',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
      {
        linkTo: '/escrituras/outbound-log',
        linkKey: 'menu_eepp_outbound_log',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
      {
        linkTo: '/escrituras/mias',
        linkKey: 'menu_eepp_mine',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
      {
        // Submenú KPI (crecerá con más métricas; hoy un solo hijo: Control SLA).
        linkKey: 'menu_eepp_kpi',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
        children: [
          {
            linkTo: '/escrituras/kpi/sla',
            linkKey: 'menu_eepp_kpi_sla',
            permission: 40,
            requiredModule: MODULE_KEY_MAP.CASES,
          },
        ],
      },
      {
        linkTo: '/escrituras/templates',
        linkKey: 'menu_eepp_templates',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
      {
        linkTo: '/escrituras/notarias',
        linkKey: 'menu_eepp_notarias',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
      {
        linkTo: '/escrituras/validators',
        linkKey: 'menu_eepp_validators',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
      {
        linkTo: '/escrituras/flags',
        linkKey: 'menu_eepp_flags',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
    ],
  },
  {
    linkKey: 'menu_admin_negotiation',
    icon: 'fileText',
    permission: 40,
    requiredModule: MODULE_KEY_MAP.CASES,
    children: [
      // oculto 2026-07: viabilidad manual — ver docs/pendientes/na-flujo-manual-seguimiento.md
      // {
      //   linkTo: '/renegotiation/viability',
      //   linkKey: 'menu_admin_negotiation_viability',
      //   requiredModule: MODULE_KEY_MAP.CASES,
      // },
      {
        linkTo: '/renegotiation/documents',
        linkKey: 'menu_admin_negotiation_documents',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
      {
        linkTo: '/renegotiation/required-documents',
        linkKey: 'menu_admin_negotiation_required_docs',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
      {
        linkTo: '/renegotiation/supervisors',
        linkKey: 'menu_admin_negotiation_supervisors',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
      {
        linkTo: '/renegotiation/config',
        linkKey: 'menu_admin_negotiation_config',
        permission: 40,
        requiredModule: MODULE_KEY_MAP.CASES,
      },
    ],
  },
  {
    linkKey: 'menu_crm',
    icon: 'users',
    anyPermission: [62, 110],
    children: [
      {
        linkTo: '/crm/clientes',
        linkKey: 'menu_clients',
        permission: 62,
        requiredModule: MODULE_KEY_MAP.CRM,
      },
      {
        linkTo: '/crm/monitoreo-rut',
        linkKey: 'menu_monitorRut',
        permission: 110,
        requiredModule: MODULE_KEY_MAP.CRM,
      },
      // { linkTo: '/crm/cobranza', linkKey: 'menu_collection' },
    ],
  },
  {
    linkKey: 'menu_smartDocs',
    icon: 'fileText',
    anyPermission: [116, 123],
    requiredModule: MODULE_KEY_MAP.SMART_DOCUMENTS,
    children: [
      {
        linkTo: '/smart-docs/gestion-documentos',
        linkKey: 'menu_docManagement',
        permission: 116,
        requiredModule: MODULE_KEY_MAP.SMART_DOCUMENTS,
      },
      {
        linkTo: '/smart-docs/registro-documentos',
        linkKey: 'menu_docRegistry',
        permission: 123,
        requiredModule: MODULE_KEY_MAP.SMART_DOCUMENTS,
      },
    ],
  },
  {
    linkKey: 'menu_messaging',
    icon: 'send',
    anyPermission: [128, 130, 136, 141],
    children: [
      {
        linkTo: '/mensajeria/crear-mensajes',
        linkKey: 'menu_createMessages',
        permission: 130,
        requiredModule: MODULE_KEY_MAP.MESSAGING,
      },
      {
        linkTo: '/mensajeria/campanas',
        linkKey: 'menu_campaigns',
        permission: 136,
        requiredModule: MODULE_KEY_MAP.MESSAGING,
      },
      {
        linkTo: '/mensajeria/tareas-notificaciones',
        linkKey: 'menu_tasksNotifications',
        permission: 141,
        requiredModule: MODULE_KEY_MAP.MESSAGING,
      },
    ],
  },
  {
    linkKey: 'menu_automation',
    icon: 'workflow',
    children: [
      {
        linkTo: '/automatizaciones/configurar-workflow-tareas',
        linkKey: 'menu_taskWorkflow',
      },
      {
        linkTo: '/automatizaciones/solicitudes-aprobacion',
        linkKey: 'menu_approvalRequest',
      },
    ],
  },
  {
    linkKey: 'menu_reports',
    icon: 'fileBarGraph',
    anyPermission: [145, 147, 150, 153, 225],
    requiredModule: MODULE_KEY_MAP.REPORTS,
    ruleKey: 'menu_reports',
    children: [
      {
        linkTo: '/informes/scoring-abogados',
        linkKey: 'menu_lawyerScoring',
        permission: 147,
        requiredModule: MODULE_KEY_MAP.REPORTS,
        ruleKey: 'menu_reports',
      },
      {
        linkTo: '/informes/uso-plantillas',
        linkKey: 'menu_docUsage',
        permission: 150,
        requiredModule: MODULE_KEY_MAP.REPORTS,
        ruleKey: 'menu_reports',
      },
      {
        linkTo: '/informes/deteccion-monitoreo',
        linkKey: 'menu_detectionMonitoring',
        permission: 153,
        requiredModule: MODULE_KEY_MAP.REPORTS,
        ruleKey: 'menu_reports',
      },
      {
        linkTo: '/informes/creador-informes',
        linkKey: 'menu_reportCreator',
        permission: 225,
        requiredModule: MODULE_KEY_MAP.REPORTS,
        ruleKey: 'menu_reports',
      },
    ],
  },
  {
    linkKey: 'menu_ai',
    icon: 'sparkles',
    permission: [158, 294],
    ruleKey: 'menu_ai',
    children: [
      {
        linkTo: '/ia/protocolos',
        linkKey: 'menu_protocols',
        permission: 158,
        requiredModule: MODULE_KEY_MAP.ARTIFICIAL_INTELLIGENCE,
        ruleKey: 'menu_ai',
      },
      {
        linkTo: '/ia/no-clientes',
        linkKey: 'menu_noClients',
        permission: 294,
        requiredModule: MODULE_KEY_MAP.ARTIFICIAL_INTELLIGENCE,
        ruleKey: 'menu_ai',
      },
    ],
  },
  {
    linkKey: 'menu_marketing',
    icon: 'fileBarGraph',
    anyPermission: [228, 229],
    children: [
      {
        linkTo: '/marketing/analisis-marketing',
        linkKey: 'menu_marketingAnalysis',
        permission: 228,
        requiredModule: MODULE_KEY_MAP.MARKETING,
        ruleKey: 'menu_marketing',
      },
      {
        linkTo: '/marketing/transcripciones-sac',
        linkKey: 'menu_marketingSacTranscripts',
        permission: 229,
        requiredModule: MODULE_KEY_MAP.MARKETING,
        ruleKey: 'menu_marketing',
      },
    ],
  },
];
